import React, { useContext, useState } from 'react'
import { useVerify } from '../../hook/useVerify'
import { DataContext } from '../../context/DataContext'
import { usePayment } from '../../hook/payment/usePayment/usePayment'
import { GenericModal, PopUpCode } from '@pinflag/pinflag-ui-kit'

const PaymentSavedInformationPopUp = () => {
  const {
    otpChannel,
    setOtpChannel,
    otpChannelsDisabled,
    setOtpChannelsDisabled,
    companyInfo,
    userInfo
  } = useContext(DataContext)

  const { names } = userInfo
  const { primaryColor } = companyInfo
  const {
    isLoadingCheckIfCustomerHasSavedCards,
    setIsUsingSavedCards,
    hasSavedCards,
    showSavedCardModal,
    setShowSavedCardModal
  } = usePayment()
  const { verifyClientCode, sendClientCode } = useVerify()
  const [isOTPLoading, setIsOTPLoading] = useState(false)

  const [codeWindow, setCodeWindow] = useState(false)
  const [triesQuantity, setTriesQuantity] = useState(0)

  /* Codigo para realizar la verificación de usuario con OTP */
  const handleClose = () => {
    setShowSavedCardModal(false)
  }

  const handleSendCode = () => {
    handleChannelSelection('email')
    setIsOTPLoading(true)

    sendClientCode().then(() => {
      setShowSavedCardModal(false)
      setCodeWindow(!codeWindow)
      setIsOTPLoading(false)
    })
  }

  const handleReturn = (setToken, setDisabled, setErrorMessage, setReset, reset) => {
    setCodeWindow(!codeWindow)
    setToken('')
    setDisabled(true)
    setReset(!reset)
    setErrorMessage(true)
  }

  const handleChannelSelection = (channel) => {
    setOtpChannel(channel)
  }

  const handleVerifyCode = (token, setErrorMessage, setIsLoadingScrapper) => {
    setIsLoadingScrapper(true)
    setIsOTPLoading(true)

    verifyClientCode(token).then((response) => {
      if (response.verified) {
        setCodeWindow(!codeWindow)
        setIsUsingSavedCards(true)
      } else if (!response.verified) {
        if (response.message === 'OTP not found') {
          setTriesQuantity(triesQuantity + 1)
          setErrorMessage('Código incorrecto o expirado')
        } else {
          setErrorMessage('Hubo un problema. Intente nuevamente.')
        }
      }

      setIsLoadingScrapper(false)
      setIsOTPLoading(false)
    })
  }

  const handleReSendCode = (setErrorMessage, setReset, reset, setThirdButtonDisabled, setDisabled, disabled) => {
    if (otpChannelsDisabled[otpChannel]) {
      setErrorMessage('Ya se ha enviado un código a este canal. Espere 30 segundos para reenviar un nuevo código.')
      return
    }

    setThirdButtonDisabled(prevState => ({
      ...prevState,
      [otpChannel]: true
    }))

    if (disabled) {
      setDisabled(false)
    }
    sendClientCode().then(() => {
      setReset(!reset)
      setErrorMessage('')
      setOtpChannelsDisabled(prevState => ({
        ...prevState,
        [otpChannel]: true
      }))

      setTimeout(() => {
        setThirdButtonDisabled(prevState => ({
          ...prevState,
          [otpChannel]: false
        }))
        setOtpChannelsDisabled(prevState => ({
          ...prevState,
          [otpChannel]: false
        }))
      }, 30000)
    })
  }

  const handleDisabled = (setErrorMessage, setDisabled) => {
    if (triesQuantity === 5) {
      setDisabled(true)
      setErrorMessage('Ha superado la cantidad de intentos. Reenvie un nuevo código.')
    }
  }

  return (
    <>
    <GenericModal
      isOpenModal={!isLoadingCheckIfCustomerHasSavedCards && hasSavedCards && showSavedCardModal && !codeWindow}
      icon={'forward-to-inbox'}
      modalTitle={`¡Hola de nuevo, ${names.substring(0, names.indexOf(' '))}!`}
      modalText={'Notamos que tienes datos de pago guardados. Puedes usar tus tarjetas verificando tu identidad.'}
      firstButton={'Comprar como invitado'}
      secondButton={'Enviar código al correo'}
      handleClose={handleClose}
      handleAction={handleSendCode}
      handleSecondAction={handleClose}
      buttonsOrientation={'column'}
      loading={isOTPLoading}
      primaryColor={primaryColor}
    />
    <PopUpCode
      isOpenModal={codeWindow}
      handleReturn={handleReturn}
      codeTitle={'Código de verificación'}
      codeText={`Ingresa el código que enviamos a ${userInfo.email} para continuar tu compra.`}
      handleVerifyCode={handleVerifyCode}
      handleReSendCode={handleReSendCode}
      firstButtonText={'Ingresar'}
      secondButtonText={'Reenviar código'}
      thirdButtonText={'Enviar un SMS'}
      handleDisabled= {handleDisabled}
      handleChannelSelection={handleChannelSelection}
      loading={isOTPLoading}
    />
    </>
  )
}

PaymentSavedInformationPopUp.propTypes = {}

export default PaymentSavedInformationPopUp
